import { render, staticRenderFns } from "./DashboardSurveyResponseView.vue?vue&type=template&id=b4c4cff4&"
import script from "./DashboardSurveyResponseView.vue?vue&type=script&lang=js&"
export * from "./DashboardSurveyResponseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports